import React from 'react'
import { Link } from 'react-router-dom'

const imgBackgroundTexture = 'https://www.figma.com/api/mcp/asset/858b58b2-8ee1-4caf-95ae-101c5e1b9d13'
const imgGroup1171275028 = 'https://www.figma.com/api/mcp/asset/f9b9495d-a958-4578-ab10-05b6fcb8fabc'
const imgSymbolSvg = '/icon/whatsapp-green.svg'
const imgInstagram = '/icon/instagram.svg'
const imgFacebook02 = '/icon/facebook-02.svg'
const imgLinkedin02 = '/icon/linkedin-02.svg'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const linkColumns = [
    { 
      title: 'Product', 
      links: [
        { text: 'Features', url: '#features', isAnchor: true },
        { text: 'Integrations', url: '#integrations', isAnchor: true },
        { text: 'Pricing', url: '/pricing' },
        { text: 'Compare', url: '#compare', isAnchor: true },
        { text: 'Tutorials', url: 'https://www.youtube.com/@nocodeshare/videos' }
      ] 
    },
    { 
      title: 'Support', 
      links: [
        { text: 'team@whatsable.app', url: 'mailto:team@whatsable.app' },
        { text: 'Login', url: 'https://console.notifyer-systems.com/sign-in' },
        { text: 'Privacy Policy', url: '/privacy-policy' },
        { text: 'Terms of Service', url: '/terms-of-service' }
      ] 
    },
    { 
      title: 'Resources', 
      links: [
        { text: 'Documentation', url: 'https://docs.whatsable.app/guides/notifier-system/embedding-process' },
        { text: 'FAQs', url: '#faq', isAnchor: true },
        { text: 'Book Demo', url: 'https://tidycal.com/axelmeta/notifyer-by-whatsable-demo-via-ads?embed=1' },
        { text: 'Free Trial', url: 'https://console.notifyer-systems.com/sign-up' },
        { text: 'Notifier (Simpler Alternative)', url: 'https://notifier.whatsable.app/sign-up' }
      ] 
    },
  ]

  return (
    <footer className="relative overflow-hidden bg-white px-6 pb-20 pt-14 text-[#1c2329] sm:px-10 sm:pt-16 sm:pb-24 lg:px-[100px] lg:pb-40 lg:pt-20">
      {/* dotted texture overlay */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgba(15,23,42,0.08) 1px, transparent 0)',
          backgroundSize: '22px 22px',
          backgroundPosition: 'right top',
          opacity: 0.35,
          transform: 'scaleX(-1)',
          transformOrigin: 'center',
        }}
        aria-hidden="true"
      />
      {/* dark vignette textures */}
      <div className="pointer-events-none absolute -left-40 -top-52 hidden h-[600px] w-[700px] rotate-180 opacity-40 md:block">
        <img src="/footer-background-left.svg" alt="" className="h-full w-full object-cover" />
      </div>
      <div className="pointer-events-none absolute -right-48 -top-52 hidden h-[620px] w-[720px] opacity-40 md:block">
        <img src="/footer-background-right.svg" alt="" className="h-full w-full object-cover" />
      </div>

      <div className="relative mx-auto flex w-full max-w-screen-xl flex-col gap-12">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.05fr_1fr] lg:items-start">
          <div className="space-y-5 text-center sm:max-w-[420px] sm:text-left">
            <h2 className="text-[30px] font-semibold leading-tight tracking-[-1px] sm:text-[36px] lg:text-[40px]">
              Ready to transform your business?
            </h2>
            <p className="text-[16px] leading-[1.7] tracking-[-0.4px] text-[#656f68]">
              Join thousands of businesses using Notifyer to automate their WhatsApp messaging.
            </p>
            <button
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.dispatchEvent(
                    new CustomEvent('openEmailModal', { detail: { source: 'footer_cta' } })
                  )
                }
              }}
              className="w-full rounded-full bg-[#1c2329] px-6 py-4 text-[15px] font-semibold tracking-[-0.4px] text-white shadow-[0px_4px_8px_rgba(36,196,211,0.1)] transition hover:-translate-y-0.5 hover:bg-[#13181d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1c2329] sm:w-[180px]"
            >
              Get Started
            </button>
          </div>

          <div className="grid grid-cols-2 gap-8 text-left sm:grid-cols-3 sm:gap-10 lg:gap-12">
            {linkColumns.map((column) => (
              <div key={column.title} className="space-y-4">
                <p className="text-[12px] font-medium uppercase tracking-[0.3px] text-[#656f68]">{column.title}</p>
                <ul className="space-y-3 text-[17px] font-medium tracking-[-0.4px]">
                  {column.links.map((item) => (
                    <li key={item.text} className="leading-[1.4]">
                      {item.url !== '#' ? (
                        item.url.startsWith('/') ? (
                          <Link 
                            to={item.url}
                            className="cursor-pointer hover:text-[#1c2329] transition-colors"
                          >
                            {item.text}
                          </Link>
                        ) : (
                          <a 
                            href={item.url}
                            onClick={(e) => {
                              if (item.isAnchor) {
                                e.preventDefault()
                                scrollToSection(item.url.substring(1))
                              } else if (item.url.startsWith('http')) {
                                e.preventDefault()
                                window.open(item.url, '_blank')
                              }
                            }}
                            className="cursor-pointer hover:text-[#1c2329] transition-colors"
                          >
                            {item.text}
                          </a>
                        )
                      ) : (
                        <span className="cursor-default">{item.text}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-6 pt-6 pb-14 sm:pb-20 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-wrap items-center justify-center gap-4 text-[15px] text-[#656f68] sm:justify-start">
            <img src="/notifyer-logo.svg" alt="Notifyer logo" className="h-7 w-auto" />
            <span className="text-center sm:text-left">© {currentYear} WhatsAble. All rights reserved.</span>
          </div>
          <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center">
            <button 
              onClick={() => window.open('https://wa.me/+13476861478?text=Hi%20WhatsAble%20team,%20I%20need%20help%20with%20your%20WhatsApp%20automation%20service', '_blank')}
              className="flex w-full items-center justify-center gap-2 rounded-full border border-[rgba(28,35,41,0.15)] px-4 py-2 text-[14px] font-medium text-[#1c2329] shadow-[0px_2px_6px_rgba(0,0,0,0.06)] transition hover:-translate-y-0.5 hover:border-[#1c2329] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1c2329] sm:w-auto"
            >
              <img src={imgSymbolSvg} alt="WhatsApp icon" className="h-5 w-5" />
              Talk to us on WhatsApp!
            </button>
            <div className="flex items-center justify-center gap-3 sm:justify-start">
              {[
                { src: imgInstagram, url: 'https://www.instagram.com/notifyer_automations/' },
                { src: imgFacebook02, url: 'https://www.facebook.com/profile.php?id=61581953854948' },
                { src: imgLinkedin02, url: 'https://www.linkedin.com/company/whatsable/' }
              ].map((item) => (
                <button
                  key={item.src}
                  onClick={() => item.url !== '#' && window.open(item.url, '_blank')}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-[rgba(28,35,41,0.15)] shadow-[0px_2px_6px_rgba(0,0,0,0.06)] transition hover:-translate-y-0.5 hover:border-[#1c2329] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1c2329]"
                >
                  <img src={item.src} alt="social icon" className="h-5 w-5" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-[0px] flex justify-center opacity-80 select-none">
        <img src="/notifyer-footer.svg" alt="notifyer" className="h-auto w-full max-w-[1240px]" />
      </div>
    </footer>
  )
}

export default Footer

